import React from 'react';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';

interface MetricSwitcherProps {
  title: string;
  onToggle: (direction: 'prev' | 'next') => void;
  disabled?: boolean;
}

export const MetricSwitcher: React.FC<MetricSwitcherProps> = ({
  onToggle,
  disabled = false,
  title = '',
}) => {
  return (
    <div className="flex items-center gap-1 border border-gray-200 rounded-lg justify-between">
      <button
        onClick={e => {
          e.stopPropagation();
          onToggle('prev');
        }}
        disabled={disabled}
        className="p-1 rounded-md hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        aria-label="Previous metric"
      >
        <ChevronLeft sx={{ fontSize: 18, color: 'var(--main)' }} />
      </button>
      <div className="text-mainText text-tiny font-semibold">{title}</div>
      <button
        onClick={e => {
          e.stopPropagation();
          onToggle('next');
        }}
        disabled={disabled}
        className="p-1 rounded-md hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        aria-label="Next metric"
      >
        <ChevronRight sx={{ fontSize: 18, color: 'var(--main)' }} />
      </button>
    </div>
  );
};

